import React from 'react';
import ReactDOM from 'react-dom/client';
import "@fontsource/public-sans/400.css";
import "@fontsource/public-sans/500.css";
import "@fontsource/public-sans/600.css";
import "@fontsource/public-sans/700.css";
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
